import './common'
import '../scss/style.scss';

import '~components/size-chart/size-chart'
import '~components/tabs/tabs'
